import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

const cookie = (n: string) =>
  document.cookie.split("; ").find((c) => c.startsWith(n + "="))?.split("=")[1];

let csrfToken: string | null = null;
// Fallback für eingebettete Vorschau ohne Cookies (Safari): Sitzung nur im Arbeitsspeicher, nie im localStorage.
const memSessions: Record<string, string> = {};
export const clearSessions = () => Object.keys(memSessions).forEach((k) => delete memSessions[k]);

api.interceptors.request.use(async (cfg) => {
  Object.entries(memSessions).forEach(([k, v]) => { cfg.headers["X-" + k.replace("_", "-")] = v; });
  if (cfg.method && cfg.method.toLowerCase() !== "get") {
    if (!csrfToken) {
      const r = await axios.get(`${BACKEND}/api/csrf`, { withCredentials: true });
      csrfToken = r.data.csrf_token;
    }
    cfg.headers["X-CSRF-Token"] = csrfToken || cookie("kd_csrf") || "";
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => {
    const s = r.headers?.["x-kd-session"];
    if (s) { const [k, v] = String(s).split("="); memSessions[k] = v; }
    return r;
  },
  (err) => {
    const st = err.response?.status;
    if ((!st || st >= 500) && err.config?.url !== "/public/fehler") reportError(`HTTP ${st || "Netzwerk"} ${err.config?.method?.toUpperCase()} ${err.config?.url || ""}`);
    if (err.response?.status === 401 && window.location.pathname.startsWith("/praxis") && err.config?.url !== "/auth/me") {
      window.location.assign("/login?abgelaufen=1");
    }
    return Promise.reject(err);
  }
);

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  if (e?.response?.status === 413) return "Die Datei ist zu groß.";
  return "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";
}

export const fileUrl = (path: string) => `${BACKEND}${path}`;

let reported = 0;
export function reportError(nachricht: string) {
  if (reported++ > 20) return;
  api.post("/public/fehler", { nachricht: String(nachricht).slice(0, 1000), route: window.location.pathname }).catch(() => undefined);
}

export async function download(path: string, filename: string, params?: any) {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export async function openBlob(path: string) {
  const r = await api.get(path, { responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank", "noopener");
}
